import { z } from 'zod';

import {
  VALIDATION_LIMITS,
  VALIDATION_MESSAGES,
} from '../constants/ValidationRules';

const MAX_FILESIZE_MB = parseInt(
  import.meta.env.VITE_UPLOAD_MAX_FILESIZE || '100',
  10
);
const MAX_FILESIZE_BYTES = MAX_FILESIZE_MB * 1_048_576;

export const uploadMultipleFileSchema = z.object({
  files: z
    .array(
      z.object({
        file: z.instanceof(File),
        description: z
          .string()
          .trim()
          .max(
            VALIDATION_LIMITS.DOCUMENT.DESCRIPTION_MAX,
            VALIDATION_MESSAGES.maxChars(
              VALIDATION_LIMITS.DOCUMENT.DESCRIPTION_MAX
            )
          )
          .optional(),
        highlighted: z.boolean(),
      })
    )
    .min(1, 'You must upload at least one file.')
    .max(
      20,
      'You can only upload 20 files at a time, please remove any extra files to continue.'
    )
    .superRefine((files, ctx) => {
      const totalSize = files.reduce((sum, f) => sum + f.file.size, 0);
      if (totalSize > MAX_FILESIZE_BYTES) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `The total file size must not exceed ${MAX_FILESIZE_MB} MB.`,
        });
      }
    }),
});

export type UploadFileSchema = z.infer<typeof uploadMultipleFileSchema>;
